import Vue from 'vue'
import store from './../store'
import plan from './../mixin/plan'
import Router from 'vue-router'
import LayoutIn from '@/components/layouts/In'
import LayoutOut from '@/components/layouts/Out'
import LayoutOffline from '@/components/layouts/Offline'
import HomeOff from '@/components/HomeOff'
import LayoutShared from '@/components/layouts/Shared'
import Access from '@/components/Access'
import AccessDenied from '@/components/AccessDenied'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import Forgot from '@/components/auth/Forgot'
import Reset from '@/components/auth/Reset'
import Dashboard from '@/components/dashboard/DashboardMovements'
import Home from '@/components/Home'
import Company from '@/components/Company'
import Team from '@/components/Team'
import User from '@/components/User'
import Connection from '@/components/Connection'
import Task from '@/components/Task'
import PTaskEditable from '@/components/shared/PTaskEditable'
import TaskLinkView from '@/components/shared/TaskLinkView'
import Tasktemplate from '@/components/Tasktemplate'
import Report from '@/components/Report'
// Ocultar os recados, bug 773
// import Message from '@/components/Message'
import File from '@/components/File'
import PCalendar from '@/components/shared/PCalendar'
import NotificationRedirect from '@/components/NotificationRedirect'
import Upgrade from '@/components/Upgrade'
import FormView from '@/components/FormView'

Vue.use(Router)

function hasPlan (entity, name) {
  // função que verifica se o usuário possui o plano com acesso para acessar a tela
  let planInterval = setInterval(() => {
    if ((store.getters[`plan/accesses`]).length > 0) {
      if (!plan.methods.checkPlanAccess(entity, 'has', -1, store.getters[`plan/accesses`]) || !plan.methods.checkPlanAccess(entity, 'active', -1, store.getters[`plan/accesses`])) {
        clearInterval(planInterval)
        store.commit('snackbar/change_values', {
          text: 'Altere o seu plano para ter acesso na tela de ' + name + '!',
          color: 'info',
          dialog: true,
          timeout: 10000
        })
        document.location.href = '#/access-denied'
      } else {
        clearInterval(planInterval)
        return ''
      }
    }
  }, 100)
}

function hasAccess (entity, name, type) {
  // função que verifica se o usuário possui o plano com acesso para acessar a tela
  let accessInterval = setInterval(() => {
    if ((store.getters[`access/permissions`]).length > 0) {
      // verifica se o usuário não possui a permissão naquela tela para o seu determinado tipo
      // Pois caso não exista aquela permissão ai pq a tela deverá ser liberada
      let hasNotPermission = (store.getters[`access/permissions`]).some((res) => {
        return res.id_text === entity && res[type] === false
      })
      if (hasNotPermission) {
        clearInterval(accessInterval)
        store.commit('snackbar/change_values', {
          text: `Você não possui permissão para ${type === 'view' ? 'visualizar' : 'gerenciar'} a tela de ${name}!`,
          color: 'warning',
          dialog: true,
          timeout: 8000
        })
        if (entity === 'tasks' && type === 'view') {
          document.location.href = '#/homepage'
        } else {
          document.location.href = '#/home'
        }
      } else {
        clearInterval(accessInterval)
        return ''
      }
    }
  }, 100)
}

function checkAccesses (entity, name, type) {
  hasPlan(entity, name)
  hasAccess(entity, name, type)
}
export default new Router({
  routes: [
    {
      path: '',
      component: LayoutOut,
      children: [
        {
          path: '/',
          name: 'Login',
          component: Login,
          alias: '/login'
        }, {
          path: '/register',
          name: 'Register',
          component: Register
        }, {
          path: '/register/:data',
          name: 'Register',
          component: Register
        }, {
          path: '/forgot',
          name: 'Forgot',
          component: Forgot
        }, {
          path: '/reset',
          name: 'Reset',
          component: Reset
        }]
    }, {
      path: '',
      component: LayoutShared,
      children: [
        {
          path: '/task_shared/:id',
          name: 'TaskShared',
          component: PTaskEditable
        }, {
          path: '/task_link_view/:id',
          name: 'TaskLinkView',
          component: TaskLinkView
        }]
    }, {
      path: '/form_view/:id',
      component: FormView
    }, {
      path: '/offline',
      component: LayoutOffline,
      children: [
        {
          path: '/',
          name: 'HomeOff',
          component: HomeOff
        }]
    }, {
      path: '',
      component: LayoutIn,
      meta: {auth: true},
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home,
          beforeEnter: (to, from, next) => {
            // Se for no smartphone abre a tela de home com as opções do menu, se for em tela maior vai para tela de tarefas
            let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if (width <= 1024) {
              next()
            } else {
              document.location.href = '#/tasks'
            }
          }
        },
        {
          path: '/homepage',
          name: 'HomePage',
          component: Home
        }, {
          path: '/upgrade',
          name: 'Upgrade',
          component: Upgrade
        }, {
          path: '/dashboard_movement',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('dashboard_movement', 'Dashboard', 'view'))
          }
        }, {
          path: '/companies',
          name: 'Companies',
          component: Company,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('companies', 'Empresas', 'view'))
          }
        }, {
          path: '/company/:id',
          name: 'Company',
          component: Company,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('companies', 'Empresas', 'manage'))
          }
        },
        {
          path: '/teams',
          name: 'Teams',
          component: Team,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('teams', 'Equipes', 'view'))
          }
        }, {
          path: '/user',
          name: 'User',
          component: User
        }, {
          path: '/connections',
          name: 'Connections',
          component: Connection,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('connections', 'Conexões', 'view'))
          }
        }, {
          path: '/accesses',
          name: 'Accesses',
          component: Access,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('accesses', 'Acessos', 'view'))
          }
        }, {
          path: '/access-denied',
          name: 'AccessDenied',
          component: AccessDenied
        },
        {
          path: '/tasks',
          name: 'Tasks',
          component: Task,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('tasks', 'Tarefas', 'view'))
          }
        },
        {
          path: '/task/:id',
          name: 'Task',
          component: PTaskEditable,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('tasks', 'Tarefas', 'manage'))
          }
        },
        {
          path: '/task/:id/:close',
          name: 'TaskClose',
          component: PTaskEditable,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('tasks', 'Tarefas', 'manage'))
          }
        }, {
          path: '/tasktemplates',
          name: 'Tasktemplates',
          component: Tasktemplate,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('tasktemplates', 'Modelos de Tarefa', 'view'))
          }
        // Ocultar os recados, bug 773
        // }, {
        //   path: '/messages',
        //   name: 'Messages',
        //   component: Message,
        //   beforeEnter: (to, from, next) => {
        //     next(checkAccesses('messages', 'Recados', 'view'))
        //   }
        }, {
          path: '/files',
          name: 'Files',
          component: File,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('files', 'Arquivos', 'view'))
          }
        }, {
          path: '/calendar',
          name: 'Calendar',
          component: PCalendar,
          beforeEnter: (to, from, next) => {
            next(checkAccesses('calendar', 'Agenda', 'view'))
          }
        }, {
          path: '/report',
          name: 'Report',
          component: Report
        }, {
          path: `/redirect/:data`,
          name: 'NotificationRedirect',
          component: NotificationRedirect
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js